// extracted by mini-css-extract-plugin
export var drawerLine = "DrawerLineItem-module--drawerLine--6027a";
export var drawerLineLabel = "DrawerLineItem-module--drawerLineLabel--c6749";
export var drawerLineValue = "DrawerLineItem-module--drawerLineValue--69d09";